import React from 'react';
import { Card, Upload, Button, List, Typography } from 'antd';
import { InboxOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

const { Dragger } = Upload;

const FileUploadTab = ({ fileList, onFileChange, onFileRemove, onFilePreview }) => {
  const uploadProps = {
    name: 'files',
    multiple: true,
    fileList,
    accept: '.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp',
    beforeUpload: (file) => {
      const isValidType = file.type === 'application/pdf' || file.type.startsWith('image/');
      if (!isValidType) {
        return false;
      }
      
      const isLt25M = file.size / 1024 / 1024 < 25;
      if (!isLt25M) {
        return false;
      }
      
      onFileChange(file);
      return false; // Prevent auto upload
    },
    onRemove: onFileRemove,
    onPreview: onFilePreview,
  };

  return (
    <Card title="Upload Files" style={{ marginBottom: 16 }}>
      <Dragger {...uploadProps} style={{ marginBottom: 16 }}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag files to this area to upload</p>
        <p className="ant-upload-hint">
          Support PDF and image files (JPG, PNG, GIF, BMP, WEBP). Max 25MB per file (large images are compressed).
          You can upload multiple pages of the same bill.
        </p>
      </Dragger>

      {fileList.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Uploaded Files ({fileList.length}):</Text>
          <List
            size="small"
            dataSource={fileList}
            renderItem={(file) => {
              const actions = [];
              
              if (file.type.startsWith('image/')) {
                actions.push(
                  <Button
                    key="preview"
                    type="link"
                    icon={<EyeOutlined />}
                    onClick={() => uploadProps.onPreview(file)}
                  >
                    Preview
                  </Button>
                );
              }
              
              actions.push(
                <Button
                  key="remove"
                  type="link"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => uploadProps.onRemove(file)}
                >
                  Remove
                </Button>
              );
              
              return (
                <List.Item actions={actions}>
                  <Text>{file.name}</Text>
                </List.Item>
              );
            }}
          />
        </div>
      )}
    </Card>
  );
};

export default FileUploadTab;
